import VueRouter from "vue-router";
import knowledgeBase from "../views/knowledgeBase"

//创建一个路由器
const router = new VueRouter({
    mode: 'history',
    // 生产部署在 /webaikn/ 子路径，路由 base 需与之对齐；本地开发用 /
    base: process.env.NODE_ENV === 'production' ? '/webaikn/' : '/',
    routes:[
        {
            path:'/',
            name:'knowledgeBase',
            component:knowledgeBase
        },
        {
            // SSO 售后技能查询：复用 AI 问答界面，meta.sso 区分模式
            // （独立 FAQ 配置、调用 /lexiang/ai/sso/stream、不展示任何文件链接）
            path:'/SSO',
            name:'knowledgeBaseSSO',
            component:knowledgeBase,
            meta: { sso: true }
        }
    ]
})

export default router;